import { AdditionalServicesEffects } from '../additional-services/additional-services.effects';
import { ApplicationModulesEffects } from '../application-modules/application-modules.effects';
import { ArkikProductsEffects } from '../arkik-products/arkik-products.effects';
import { BusinessPlantDetailEffects } from '../business-plant-detail/business-plant-detail.effects';
import { CalendarsPartnerEffects } from '../calendars-partner/calendars-partner.effects';
import { CatalogsVehicleEffects } from '../catalog-vehicle/catalog-vehicle.effects';
import { CatalogsEffects } from '../catalogs/catalogs.effects';
import { CompanyInfoEffects } from '../company-info/company-info.effects';
import { DriverManagementDriversEffects } from '../driver-management-drivers/driver-management-drivers.effects';
import { FeatureAvailabilityEffects } from '../feature-availability/feature-availability.effects';
import { GroupCatalogsEffects } from '../group-catalogs/group-catalogs.effects';
import { InventoryByPlantEffects } from '../inventory-by-plant/inventory-by-plant.effects';
import { LoginEffects } from '../login/login.effects';
import { MenuByUserEffects } from '../menu-by-user/menu-by-user.effects';
import { NewOrderSelectEffects } from '../new-order-select/new-order-select.effects';
import { OrderCodeEffects } from '../order-code/order-code.effects';
import { ParametersEffects } from '../parameter-by-detail/parameter-by-detail.effects';
import { PlantListCompanyByUserGuidEffects } from '../plant-list-company-by-userguid/plant-list-company-by-userguid.effects';
import { PlantListCompanyEffects } from '../plant-list-company/plant-list-company.effects';
import { PlantListUserGuidEffects } from '../plant-list-userguid/plant-list-userguid.effects';
import { PlantNetworkEffects } from '../plant-network-status/plant-network-status.effects';
import { PlantsWithBOMByProductListEffects } from '../plants-with-bom-by-product-list/plants-with-bom-by-product-list.effects';
import { ProductPriceEffects } from '../product-price/product-price.effects';
import { UserRolesEffects } from '../user-roles/user-roles.effects';
import { VariableDosageEffects } from '../variable-dosage/variable-dosage.effects';

export const appEffects = [
  AdditionalServicesEffects,
  ApplicationModulesEffects,
  ArkikProductsEffects,
  BusinessPlantDetailEffects,
  CatalogsEffects,
  CatalogsVehicleEffects,
  CompanyInfoEffects,
  GroupCatalogsEffects,
  LoginEffects,
  MenuByUserEffects,
  OrderCodeEffects,
  ParametersEffects,
  PlantListCompanyByUserGuidEffects,
  PlantListCompanyEffects,
  PlantListUserGuidEffects,
  UserRolesEffects,
  PlantNetworkEffects,
  NewOrderSelectEffects,
  VariableDosageEffects,
  InventoryByPlantEffects,
  PlantsWithBOMByProductListEffects,
  CalendarsPartnerEffects,
  DriverManagementDriversEffects,
  ProductPriceEffects,
  FeatureAvailabilityEffects,
];
